module.exports = __webpack_public_path__ + "img/buy_cart_remove.dcc57186.png";